module.exports = __webpack_public_path__ + "static/media/07_thumbnail.42568a71.jpg";